/** Backenddagi ReturnItemCondition enum bilan mos (int qiymatlar). */
export enum ReturnItemCondition {
  /** Yaroqli — qayta sotiladi. */
  Sellable = 0,
  /** Yaroqsiz / brak. */
  Defective = 1,
  /** Qadoq ochilgan / buzilgan. */
  Opened = 2,
  /** Muddati o'tgan. */
  Expired = 3,
}

export interface CreateReturnItemRequest {
  productId: string;
  quantity: number;
  productVariantId?: string | null;
  condition: ReturnItemCondition;
  /** null → kondisiyadan aniqlanadi (Sellable=true). */
  restockToSellable?: boolean | null;
  /** null → (unitPrice−discount)×quantity. Brak uchun qisman/0 berish mumkin. */
  refundAmount?: number | null;
}

export interface CreateReturnRequest {
  orderId: string;
  items: CreateReturnItemRequest[];
  reason: string;
  cashierId?: string | null;
  withheldAmount?: number | null;
}

export interface ReturnItemDto {
  productId: string;
  productName: string;
  quantity: number;
  unitPrice: number;
  discount: number;
  refundAmount: number;
  condition: ReturnItemCondition;
  restockedToSellable: boolean;
}

export interface ReturnDto {
  id: string;
  orderId: string;
  storeId: string;
  storeName: string;
  cashierId: string;
  cashierName: string;
  reason: string;
  totalRefundAmount: number;
  createdAt: string;
  items: ReturnItemDto[];
  /** Buyurtma valyutasi — `totalRefundAmount` va qator summalari shunda. */
  currency: string;
  /** Mijozga qaytarilgan pul qaysi valyutada berilgani. */
  refundCurrency: string;
  /** ASL sotuv kursi — bugungisi emas (I10). */
  refundRate: number;
  /** Kassadan chiqqan real summa, `refundCurrency` da. */
  cashPaidOut: number;
}
